export default "__VITE_ASSET__6ffdcb08__"